// extracted by mini-css-extract-plugin
export default {"homeTab":"HomeTab_homeTab__NUsz3","modalOpen":"HomeTab_modalOpen__yZzOt","tableWrapper":"HomeTab_tableWrapper__GbJjC"};